export default __webpack_public_path__ + "static/media/saleem.bdcd9775.jpg";